import React, { useState } from "react";
import { XCircle, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../../components/ui/dialog";

const RejectDialog = ({ open, app, onCancel, onConfirm, submitting }) => {
  const [reason, setReason] = useState("");
  const valid = reason.trim().length >= 5;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) { setReason(""); onCancel(); } }}>
      <DialogContent data-testid="reject-dialog" className="max-w-md rounded-3xl p-6 font-montserrat">
        <DialogTitle className="flex items-center gap-2 font-extrabold text-[18px] text-black">
          <XCircle size={18} className="text-[#ff603e]" /> Rechazar solicitud {app?.reference}
        </DialogTitle>
        <DialogDescription className="text-[13px] font-medium text-black/55">
          Indica el motivo. Se enviará al comercio ({app?.representative?.email}) junto con el aviso de rechazo.
        </DialogDescription>
        <textarea
          data-testid="reject-reason"
          className="mt-2 w-full min-h-[110px] px-3.5 py-2.5 text-[13px] font-semibold text-black bg-white border-2 border-black/10 rounded-xl focus:border-[#ff603e] focus:outline-none resize-y"
          placeholder="Ej: La cédula del representante está vencida y el aviso de operaciones no coincide con el RUC."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={600}
        />
        <div className="flex items-center justify-between gap-3">
          <span className="text-[11px] font-medium text-black/40">{reason.trim().length}/600 · mínimo 5 caracteres</span>
          <div className="flex gap-2">
            <button data-testid="reject-cancel" onClick={() => { setReason(""); onCancel(); }} className="text-[12px] font-bold text-black px-4 py-2.5 rounded-full border-2 border-black/15 hover:border-black transition-colors">Cancelar</button>
            <button
              data-testid="reject-confirm"
              disabled={!valid || submitting}
              onClick={() => onConfirm(reason.trim())}
              className="inline-flex items-center gap-1.5 text-[12px] font-bold text-white bg-[#ff603e] hover:bg-[#e04f2f] px-4 py-2.5 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting ? <Loader2 size={13} className="animate-spin" /> : <XCircle size={13} />} Rechazar y notificar
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RejectDialog;
